import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './App';
import { Honeybadger, HoneybadgerErrorBoundary } from '@honeybadger-io/react';

// Only initialize Honeybadger on *.vercel.app domains
const isVercelDomain =
  typeof window !== 'undefined' &&
  window.location.hostname.endsWith('.vercel.app');

const honeybadger =
  isVercelDomain && process.env.REACT_APP_HONEYBADGER_API_KEY
    ? Honeybadger.configure({
        apiKey: process.env.REACT_APP_HONEYBADGER_API_KEY,
        environment: 'production',
      })
    : null;

ReactDOM.render(
  honeybadger ? (
    <HoneybadgerErrorBoundary honeybadger={honeybadger}>
      <App />
    </HoneybadgerErrorBoundary>
  ) : (
    <App />
  ),
  document.getElementById('root')
);
